import * as React from 'react';
import { Input, EVisualSize } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils';
import { Field } from 'formik';
import { useFieldHasErrors } from './utils';
import { Label } from './Label';
import * as styles from '../index.css';

export const Phone = () => {
  const invalid = useFieldHasErrors('phone');

  return (
    <div {...mergeStyles(styles['field'])}>
      <Label invalid={invalid}>Телефон для связи</Label>
      <div className={styles['phone-input-container']}>
        <span className={styles['phone-prefix']}>+7</span>
        <Field
          name="phone"
          as={Input}
          custom={{ invalid, size: EVisualSize.DESKTOP }}
          __classNames={styles['phone-input']}
        />
      </div>
    </div>
  );
};
